// Batch 4 (final): Slovenian (sl), Spanish (es), Czech (cs), Hungarian (hu).
// Merged into the main translations object via translations.js.

export const EXTRA_LANG_TRANSLATIONS_4 = {
    // ---------------- HEADER ----------------
    header_tagline: {
        sl: "V nujnem primeru vedno najprej",
        es: "En emergencia, siempre primero",
        cs: "V nouzi vždy nejdřív",
        hu: "Vészhelyzetben mindig először",
    },
    header_emergency_number: {
        sl: "Reševalna služba {num}",
        es: "Servicio de emergencia {num}",
        cs: "Záchranná služba {num}",
        hu: "Mentőszolgálat {num}",
    },
    header_scan_call: {
        sl: "Scan & Call",
        es: "Scan & Call",
        cs: "Scan & Call",
        hu: "Scan & Call",
    },
    header_qr_hint: {
        sl: "Nujna pomoč prek QR",
        es: "Ayuda de emergencia por QR",
        cs: "Nouzová pomoc přes QR",
        hu: "Vészhelyzeti segítség QR-kóddal",
    },
    header_clear_location: {
        sl: "Odstrani shranjeno lokacijo",
        es: "Borrar ubicación guardada",
        cs: "Smazat uloženou polohu",
        hu: "Mentett hely törlése",
    },

    // ---------------- LANGUAGE PICKER ----------------
    language_label: {
        sl: "Jezik",
        es: "Idioma",
        cs: "Jazyk",
        hu: "Nyelv",
    },

    // ---------------- LANDING ----------------
    landing_emergency_title: {
        sl: "Nujni primer?",
        es: "¿Emergencia?",
        cs: "Nouzový případ?",
        hu: "Vészhelyzet?",
    },
    landing_emergency_sub: {
        sl: "Začni glasovno vodeno pomoč.",
        es: "Inicia la ayuda guiada por voz.",
        cs: "Spustit hlasově řízenou pomoc.",
        hu: "Indítsa el a hangvezérelt segítséget.",
    },
    landing_demo_label: { sl: "Demo", es: "Demo", cs: "Demo", hu: "Demo" },
    landing_demo_title: {
        sl: "Nimam nujnega primera, a želim videti, kako deluje.",
        es: "No tengo una emergencia pero quiero ver cómo funciona.",
        cs: "Nemám nouzový případ, ale chci vidět, jak to funguje.",
        hu: "Nincs vészhelyzetem, de látni szeretném, hogyan működik.",
    },
    landing_demo_sub: { sl: "", es: "", cs: "", hu: "" },
    landing_aed_button: {
        sl: "Odpri zemljevid defibrilatorjev",
        es: "Abrir mapa de desfibriladores",
        cs: "Otevřít mapu defibrilátorů",
        hu: "Defibrillátor-térkép megnyitása",
    },
    landing_aed_button_sub: {
        sl: "Poišči defibrilatorje v bližini",
        es: "Encuentra desfibriladores cercanos",
        cs: "Najít defibrilátory v okolí",
        hu: "Defibrillátorok keresése a közelben",
    },
    landing_disclaimer_full: {
        sl: "Podane informacije so zgolj v pomoč. Uporaba je na lastno odgovornost in ne nadomešča lastne presoje stanja ali strokovnih navodil na kraju samem. Brez jamstva za točnost. V dvomu vedno pokličite {notruf}.",
        es: "La información proporcionada sirve únicamente como orientación. El uso es bajo su propio riesgo y no sustituye su propia evaluación de la situación ni las instrucciones profesionales en el lugar. Sin garantía de exactitud. En caso de duda llame siempre al {notruf}.",
        cs: "Uvedené informace slouží pouze jako vodítko. Použití je na vlastní riziko a nenahrazuje vlastní posouzení situace ani odborné pokyny na místě. Bez záruky správnosti. V případě pochybností vždy volejte {notruf}.",
        hu: "A megadott információk csak tájékoztató jellegűek. A használat saját felelősségre történik és nem helyettesíti a saját helyzetértékelést vagy a helyszíni szakmai utasításokat. A pontosságért nem vállalunk garanciát. Kétség esetén mindig hívja a {notruf}.",
    },
    landing_disclaimer_notruf: {
        sl: "številka v sili {num}",
        es: "número de emergencia {num}",
        cs: "tísňové číslo {num}",
        hu: "segélyhívó szám {num}",
    },
    landing_unsure_full: {
        sl: "Negotov? V dvomu pokliči {notruf}!",
        es: "¿Inseguro? En caso de duda, ¡realiza una {notruf}!",
        cs: "Nejste si jistí? V případě pochybností proveďte {notruf}!",
        hu: "Bizonytalan? Kétség esetén indítson {notruf}!",
    },
    landing_unsure_notruf: {
        sl: "klic v sili",
        es: "llamada de emergencia",
        cs: "tísňové volání",
        hu: "segélyhívás",
    },
    landing_skip_to_cpr: {
        sl: "Preskoči neposredno na oživljanje",
        es: "Saltar directamente a la reanimación",
        cs: "Přeskočit rovnou na resuscitaci",
        hu: "Ugrás közvetlenül az újraélesztésre",
    },
    landing_skip_to_cpr_sub: {
        sl: "V demo načinu, brez vprašanj triaže.",
        es: "En modo demo, sin preguntas de triaje.",
        cs: "V demo režimu, bez otázek triáže.",
        hu: "Demo módban, triázs kérdések nélkül.",
    },
    footer_privacy: {
        sl: "Zasebnost",
        es: "Privacidad",
        cs: "Soukromí",
        hu: "Adatvédelem",
    },
    footer_imprint: {
        sl: "Kolofon",
        es: "Aviso legal",
        cs: "Tiráž",
        hu: "Impresszum",
    },

    // ---------------- SCAN & CALL BANNER ----------------
    scancall_title: {
        sl: "Verigo reševanja digitaliziramo.",
        es: "Estamos digitalizando la cadena de rescate.",
        cs: "Digitalizujeme záchranný řetězec.",
        hu: "Digitálissá tesszük a mentési láncot.",
    },
    scancall_sub: {
        sl: "Plakat za prvo pomoč v nekaj minutah – skladen z DGUV in doživljenjsko brezplačen.",
        es: "Cartel de primeros auxilios en minutos – conforme con DGUV y gratis de por vida.",
        cs: "Plakát první pomoci za pár minut – v souladu s DGUV a doživotně zdarma.",
        hu: "Elsősegély-poszter percek alatt – DGUV-kompatibilis és életre szóló ingyenes.",
    },
    scancall_bullet_1: {
        sl: "Klic v sili, prvi posredovalci in lokacija na prvi pogled",
        es: "Llamada de emergencia, primeros respondedores y ubicación de un vistazo",
        cs: "Tísňové volání, první zasahující a poloha na první pohled",
        hu: "Segélyhívás, elsősegélynyújtók és helyszín egy pillantásra",
    },
    scancall_bullet_2: {
        sl: "Neposredno na pametni telefon prek QR-kode",
        es: "Directo al smartphone vía código QR",
        cs: "Přímo do smartphonu přes QR kód",
        hu: "Egyenesen az okostelefonra QR-kóddal",
    },
    scancall_bullet_3: {
        sl: "Plakat skladen z DGUV – takoj pripravljen za uporabo",
        es: "Cartel conforme con DGUV – listo para usar de inmediato",
        cs: "Plakát dle DGUV – okamžitě připravený k použití",
        hu: "DGUV-kompatibilis poszter – azonnal használatra kész",
    },
    scancall_cta: {
        sl: "Začni zdaj",
        es: "Empezar ahora",
        cs: "Začít nyní",
        hu: "Indítás most",
    },

    // ---------------- EMAIL POPUP ----------------
    email_popup_title: {
        sl: "Ostani obveščen",
        es: "Mantente al día",
        cs: "Buďte v obraze",
        hu: "Maradjon naprakész",
    },
    email_popup_body: {
        sl: "Veseli nas, da preizkušaš SafetyAssist. To nujno pomoč nenehno izboljšujemo. Pusti svoj e-naslov in prejmi posodobitve takoj, ko bodo na voljo nove funkcije.",
        es: "Nos alegra que pruebes SafetyAssist. Mejoramos esta ayuda de emergencia constantemente. Deja tu correo y recibirás actualizaciones en cuanto haya nuevas funciones.",
        cs: "Jsme rádi, že zkoušíte SafetyAssist. Tuto nouzovou pomoc neustále vylepšujeme. Zanechte svůj e-mail a dostanete novinky, jakmile přibudou nové funkce.",
        hu: "Örülünk, hogy kipróbálja a SafetyAssist-et. Folyamatosan fejlesztjük ezt a vészhelyzeti segítséget. Adja meg az e-mail címét és értesítjük, amint új funkciók érkeznek.",
    },
    email_popup_email_placeholder: {
        sl: "ti@email.si",
        es: "tu@email.es",
        cs: "ty@email.cz",
        hu: "te@email.hu",
    },
    email_popup_consent: {
        sl: "S pošiljanjem se strinjam, da se moj e-naslov shrani in uporabi za pošiljanje posodobitev SafetyAssist.",
        es: "Al enviar acepto que mi correo se almacene y se use para enviar actualizaciones de SafetyAssist.",
        cs: "Odesláním souhlasím s uložením mé e-mailové adresy a jejím použitím pro zasílání novinek SafetyAssist.",
        hu: "A küldéssel hozzájárulok, hogy e-mail címem tárolásra kerüljön és a SafetyAssist frissítéseinek küldésére használják.",
    },
    email_popup_submit: {
        sl: "Naroči se",
        es: "Suscribirse",
        cs: "Přihlásit se",
        hu: "Feliratkozás",
    },
    email_popup_later: {
        sl: "Mogoče kasneje",
        es: "Quizá más tarde",
        cs: "Možná později",
        hu: "Talán később",
    },
    email_popup_thanks: {
        sl: "Hvala! Oglasili se bomo takoj, ko bo kaj novega.",
        es: "¡Gracias! Te avisaremos en cuanto haya novedades.",
        cs: "Děkujeme! Ozveme se, jakmile budou novinky.",
        hu: "Köszönjük! Jelentkezünk, amint hír lesz.",
    },
    email_popup_error_email: {
        sl: "Vnesi veljaven e-naslov.",
        es: "Introduce una dirección de correo válida.",
        cs: "Zadejte platnou e-mailovou adresu.",
        hu: "Adjon meg érvényes e-mail címet.",
    },
    email_popup_error_consent: {
        sl: "Strinjaj se s shranjevanjem e-naslova.",
        es: "Acepta el almacenamiento de tu correo.",
        cs: "Souhlaste s uložením vaší e-mailové adresy.",
        hu: "Fogadja el az e-mail címe tárolását.",
    },

    // ---------------- SAFETY BRIEFING ----------------
    safety_title: {
        sl: "Varnostna navodila",
        es: "Instrucciones de seguridad",
        cs: "Bezpečnostní pokyny",
        hu: "Biztonsági utasítások",
    },
    safety_line_1: {
        sl: "Ostani miren!",
        es: "¡Mantén la calma!",
        cs: "Zachovejte klid!",
        hu: "Maradjon nyugodt!",
    },
    safety_line_2: {
        sl: "Zavaruj mesto nesreče!",
        es: "¡Asegura el lugar del accidente!",
        cs: "Zajistěte místo nehody!",
        hu: "Biztosítsa a baleset helyét!",
    },
    safety_line_3: {
        sl: "Pazi na lastno varnost.",
        es: "Cuida tu propia seguridad.",
        cs: "Dbejte na vlastní bezpečnost.",
        hu: "Vigyázzon a saját biztonságára.",
    },
    safety_line_4: {
        sl: "Po potrebi reši osebo iz nevarnega območja.",
        es: "Si es necesario, saca a la persona de la zona de peligro.",
        cs: "V případě potřeby vyveďte osobu z nebezpečné zóny.",
        hu: "Szükség esetén vigye ki a személyt a veszélyzónából.",
    },
    safety_hint: {
        sl: "Nisi sam – {num} zgoraj je vedno dosegljiv.",
        es: "No estás solo – {num} arriba está siempre disponible.",
        cs: "Nejste sami – {num} nahoře je vždy dostupné.",
        hu: "Nincs egyedül – a {num} fent mindig elérhető.",
    },
    safety_continue: {
        sl: "Naprej",
        es: "Continuar",
        cs: "Pokračovat",
        hu: "Tovább",
    },

    // ---------------- TRIAGE ----------------
    triage_assessment: {
        sl: "Začetna ocena",
        es: "Evaluación inicial",
        cs: "Počáteční posouzení",
        hu: "Kezdeti felmérés",
    },
    triage_demo_badge: { sl: "Demo", es: "Demo", cs: "Demo", hu: "Demo" },
    triage_check_person: {
        sl: "Preveri osebo",
        es: "Comprueba a la persona",
        cs: "Zkontrolujte osobu",
        hu: "Ellenőrizze a személyt",
    },
    triage_question_label: {
        sl: "Vprašanje",
        es: "Pregunta",
        cs: "Otázka",
        hu: "Kérdés",
    },
    triage_consciousness_title: {
        sl: "Je oseba pri zavesti?",
        es: "¿Está consciente la persona?",
        cs: "Je osoba při vědomí?",
        hu: "Eszméleténél van a személy?",
    },
    triage_consciousness_sub: {
        sl: "Odzove se",
        es: "Responde",
        cs: "Reaguje",
        hu: "Reagál",
    },
    triage_consciousness_tts: {
        sl: "Je oseba pri zavesti? Ali se odziva?",
        es: "¿Está consciente la persona? ¿Responde?",
        cs: "Je osoba při vědomí? Reaguje?",
        hu: "Eszméleténél van a személy? Reagál?",
    },
    triage_advice_conscious_title: {
        sl: "Pomagaj glede na situacijo",
        es: "Ayuda según la situación",
        cs: "Pomozte podle situace",
        hu: "Segítsen a helyzetnek megfelelően",
    },
    triage_advice_conscious_body: {
        sl: "npr. oskrbi rano, pomiri osebo, zaščiti pred podhladitvijo.",
        es: "p. ej. trata heridas, calma a la persona, protégela de la hipotermia.",
        cs: "např. ošetřete ránu, uklidněte osobu, chraňte před podchlazením.",
        hu: "pl. lássa el a sebet, nyugtassa meg a személyt, óvja a kihűléstől.",
    },
    triage_advice_conscious_tts: {
        sl: "Pomagaj glede na situacijo, na primer oskrbi rano. Nato pritisni velik rdeč gumb v sili.",
        es: "Ayuda según la situación, por ejemplo trata las heridas. Luego pulsa el gran botón rojo de emergencia.",
        cs: "Pomozte podle situace, například ošetřete ránu. Poté stiskněte velké červené tísňové tlačítko.",
        hu: "Segítsen a helyzetnek megfelelően, például lássa el a sebet. Ezután nyomja meg a nagy piros vészhívó gombot.",
    },
    triage_breathing_title: {
        sl: "Ali oseba diha?",
        es: "¿Está respirando la persona?",
        cs: "Dýchá osoba?",
        hu: "Lélegzik a személy?",
    },
    triage_breathing_sub: {
        sl: "Poglej, poslušaj, čuti",
        es: "Mira, escucha, siente",
        cs: "Dívejte se, poslouchejte, ciťte",
        hu: "Nézze, hallgassa, érezze",
    },
    triage_breathing_tts: {
        sl: "Ali oseba diha? Preveri tako, da pogledaš, poslušaš in čutiš.",
        es: "¿Está respirando la persona? Comprueba mirando, escuchando y sintiendo.",
        cs: "Dýchá osoba? Zkontrolujte zrakem, sluchem a hmatem.",
        hu: "Lélegzik a személy? Ellenőrizze nézéssel, hallgatózással és érintéssel.",
    },
    triage_advice_breathing_title: {
        sl: "Stabilen bočni položaj",
        es: "Posición lateral de seguridad",
        cs: "Stabilizovaná poloha na boku",
        hu: "Stabil oldalfekvés",
    },
    triage_advice_breathing_body: {
        sl: "Osebo daj v stabilen bočni položaj in spremljaj dihanje.",
        es: "Coloca a la persona en posición lateral de seguridad y vigila la respiración.",
        cs: "Uložte osobu do stabilizované polohy na boku a sledujte dýchání.",
        hu: "Helyezze a személyt stabil oldalfekvésbe és figyelje a légzést.",
    },
    triage_advice_breathing_tts: {
        sl: "Osebo daj v stabilen bočni položaj. Nato pritisni velik rdeč gumb v sili.",
        es: "Coloca a la persona en posición lateral de seguridad. Luego pulsa el gran botón rojo de emergencia.",
        cs: "Uložte osobu do stabilizované polohy na boku. Poté stiskněte velké červené tísňové tlačítko.",
        hu: "Helyezze a személyt stabil oldalfekvésbe. Ezután nyomja meg a nagy piros vészhívó gombot.",
    },
    triage_advice_no_breath_title: {
        sl: "Brez zavesti in brez dihanja – Takoj pokliči",
        es: "Sin consciencia y sin respiración – Llama ya",
        cs: "Bez vědomí a bez dechu – Volejte ihned",
        hu: "Nincs eszmélet, nincs légzés – Hívjon azonnal",
    },
    triage_advice_no_breath_body: {
        sl: "Takoj pokliči {num} in začni s stiski prsnega koša (30:2).",
        es: "Llama de inmediato al {num} y comienza las compresiones torácicas (30:2).",
        cs: "Okamžitě volejte {num} a začněte stlačovat hrudník (30:2).",
        hu: "Azonnal hívja a {num} számot és kezdje el a mellkaskompressziókat (30:2).",
    },
    triage_advice_no_breath_tts: {
        sl: "Brez zavesti in brez dihanja. Takoj pritisni velik rdeč gumb v sili in začni oživljanje.",
        es: "Sin consciencia y sin respiración. Pulsa de inmediato el gran botón rojo de emergencia y comienza la reanimación.",
        cs: "Bez vědomí a bez dechu. Okamžitě stiskněte velké červené tísňové tlačítko a začněte resuscitaci.",
        hu: "Nincs eszmélet és nincs légzés. Azonnal nyomja meg a nagy piros vészhívó gombot és kezdje el az újraélesztést.",
    },
    triage_yes: { sl: "Da", es: "Sí", cs: "Ano", hu: "Igen" },
    triage_no: { sl: "Ne", es: "No", cs: "Ne", hu: "Nem" },
    triage_advice_label: {
        sl: "Priporočilo",
        es: "Recomendación",
        cs: "Doporučení",
        hu: "Javaslat",
    },
    triage_emergency_call: {
        sl: "Klic v sili {num}",
        es: "Emergencia {num}",
        cs: "Tíseň {num}",
        hu: "Vészhívás {num}",
    },
    triage_demo_alert_urgent: {
        sl: "V resničnem nujnem primeru bi se tukaj sprožil klic na {num}.",
        es: "En una emergencia real, aquí se activaría la llamada al {num}.",
        cs: "Ve skutečné nouzi by se zde spustil hovor na {num}.",
        hu: "Valódi vészhelyzetben itt elindulna a hívás a {num} számra.",
    },
    triage_demo_alert_generic: {
        sl: "V resničnem nujnem primeru bi se tukaj sprožil klic na {num}.",
        es: "En una emergencia real, aquí se activaría la llamada al {num}.",
        cs: "Ve skutečné nouzi by se zde spustil hovor na {num}.",
        hu: "Valódi vészhelyzetben itt elindulna a hívás a {num} számra.",
    },
    breadcrumb_conscious_no: {
        sl: "Brez zavesti",
        es: "Sin consciencia",
        cs: "Bez vědomí",
        hu: "Nincs eszméleténél",
    },
    breadcrumb_conscious_yes: {
        sl: "Pri zavesti",
        es: "Consciente",
        cs: "Při vědomí",
        hu: "Eszméleténél",
    },
    breadcrumb_breathing_no: {
        sl: "Ne diha",
        es: "No respira",
        cs: "Nedýchá",
        hu: "Nem lélegzik",
    },
    breadcrumb_breathing_yes: {
        sl: "Diha",
        es: "Respira",
        cs: "Dýchá",
        hu: "Lélegzik",
    },
    breadcrumb_called_112: {
        sl: "Klic v sili opravljen",
        es: "Llamada de emergencia realizada",
        cs: "Tísňové volání provedeno",
        hu: "Segélyhívás megtörtént",
    },
    demo_banner_label: {
        sl: "Demo način aktiven",
        es: "Modo demo activo",
        cs: "Demo režim aktivní",
        hu: "Demo mód aktív",
    },
    demo_tts_prefix: {
        sl: "Demo način.",
        es: "Modo demo.",
        cs: "Demo režim.",
        hu: "Demo mód.",
    },

    // ---------------- CPR ----------------
    cpr_waiting_title: {
        sl: "Klicanje {num}…",
        es: "Llamando al {num}…",
        cs: "Volání {num}…",
        hu: "Hívás: {num}…",
    },
    cpr_waiting_body: {
        sl: "Govori z dispečerjem. Ko se vrneš v aplikacijo, se vodeno oživljanje samodejno začne.",
        es: "Habla con el operador. Cuando vuelvas a la app, la reanimación guiada empieza automáticamente.",
        cs: "Mluvte s dispečerem. Jakmile se vrátíte do aplikace, vedená resuscitace se spustí automaticky.",
        hu: "Beszéljen a diszpécserrel. Amint visszatér az alkalmazásba, a vezetett újraélesztés automatikusan elindul.",
    },
    cpr_start_now: {
        sl: "Začni zdaj",
        es: "Empezar ahora",
        cs: "Začít nyní",
        hu: "Indítás most",
    },
    cpr_intro_title: {
        sl: "Izvedi oživljanje",
        es: "Realizar reanimación",
        cs: "Provést resuscitaci",
        hu: "Újraélesztés végrehajtása",
    },
    cpr_intro_body: {
        sl: "Pritisni 2× na sekundo – 30×, nato 2 vdiha.",
        es: "Presiona 2× por segundo – 30 veces, después 2 insuflaciones.",
        cs: "Stlačujte 2× za sekundu – 30×, potom 2 vdechy.",
        hu: "Nyomja 2× másodpercenként – 30×, majd 2 lélegeztetés.",
    },
    cpr_intro_tts: {
        sl: "Izvedi oživljanje. Pritisni dvakrat na sekundo trideset krat in nato dva vdiha.",
        es: "Realiza la reanimación. Presiona dos veces por segundo, treinta veces, y luego haz dos insuflaciones.",
        cs: "Proveďte resuscitaci. Stlačujte dvakrát za sekundu třicetkrát a potom dvě vdechnutí.",
        hu: "Végezze az újraélesztést. Nyomjon másodpercenként kétszer harmincszor, majd két lélegeztetés.",
    },
    cpr_start_immediately: {
        sl: "Naprej",
        es: "Continuar",
        cs: "Pokračovat",
        hu: "Tovább",
    },
    cpr_active_title: {
        sl: "Izvajaj oživljanje!",
        es: "¡Realiza la RCP!",
        cs: "Provádějte resuscitaci!",
        hu: "Végezze az újraélesztést!",
    },
    cpr_reanimation: {
        sl: "Oživljanje",
        es: "Reanimación",
        cs: "Resuscitace",
        hu: "Újraélesztés",
    },
    cpr_counter_compressions: {
        sl: "{n}/30 stiskov",
        es: "{n}/30 compresiones",
        cs: "{n}/30 stlačení",
        hu: "{n}/30 nyomás",
    },
    cpr_counter_breaths: {
        sl: "{n}/2 vdihov",
        es: "{n}/2 insuflaciones",
        cs: "{n}/2 vdechy",
        hu: "{n}/2 lélegeztetés",
    },
    cpr_label_compress: {
        sl: "Pritisni",
        es: "Presiona",
        cs: "Stlačit",
        hu: "Nyomás",
    },
    cpr_label_breathe: {
        sl: "Vdihni",
        es: "Insufla",
        cs: "Dýchat",
        hu: "Lélegeztetés",
    },
    cpr_bpm_line: {
        sl: "110 BPM · 545 ms na stisk",
        es: "110 BPM · 545 ms por compresión",
        cs: "110 BPM · 545 ms na stlačení",
        hu: "110 BPM · 545 ms nyomásonként",
    },
    cpr_timer_suffix: {
        sl: "30× pritisni · 2× vdihni",
        es: "30× presionar · 2× insuflaciones",
        cs: "30× stlačit · 2× vdechy",
        hu: "30× nyomás · 2× lélegeztetés",
    },
    cpr_continue_hint: {
        sl: "Nadaljuj, dokler ne pride pomoč.",
        es: "Continúa hasta que llegue la ayuda.",
        cs: "Pokračujte, dokud nedorazí pomoc.",
        hu: "Folytassa, amíg meg nem érkezik a segítség.",
    },
    cpr_handover_tts: {
        sl: "Pokliči zamenjavo!",
        es: "¡Pide un relevo!",
        cs: "Zavolejte střídání!",
        hu: "Kérjen váltást!",
    },
    cpr_breath_tts: {
        sl: "Vdihni",
        es: "Insufla",
        cs: "Dýchat",
        hu: "Lélegeztetés",
    },
    cpr_show_aed: {
        sl: "Defibrilator v bližini",
        es: "Desfibrilador cercano",
        cs: "Defibrilátor v okolí",
        hu: "Defibrillátor a közelben",
    },

    // ---------------- AED ----------------
    aed_back: { sl: "Nazaj", es: "Atrás", cs: "Zpět", hu: "Vissza" },
    aed_section_label: {
        sl: "Iskanje defibrilatorja",
        es: "Búsqueda de desfibrilador",
        cs: "Hledání defibrilátoru",
        hu: "Defibrillátor keresése",
    },
    aed_confirm_title: {
        sl: "Ali ste še vedno na tej lokaciji?",
        es: "¿Sigues en esta ubicación?",
        cs: "Jste stále na této poloze?",
        hu: "Még mindig ezen a helyen van?",
    },
    aed_confirm_yes: {
        sl: "Da, nadaljuj",
        es: "Sí, continuar",
        cs: "Ano, pokračovat",
        hu: "Igen, tovább",
    },
    aed_confirm_no: {
        sl: "Ne, nova lokacija",
        es: "No, nueva ubicación",
        cs: "Ne, nová poloha",
        hu: "Nem, új hely",
    },
    aed_detecting_title: {
        sl: "Iskanje lokacije…",
        es: "Detectando ubicación…",
        cs: "Zjišťování polohy…",
        hu: "Helymeghatározás…",
    },
    aed_detecting_sub: {
        sl: "Dovoli dostop do lokacije v pogovornem oknu brskalnika.",
        es: "Permite el acceso a la ubicación en el diálogo del navegador.",
        cs: "Povolte přístup k poloze v dialogu prohlížeče.",
        hu: "Engedélyezze a helyhozzáférést a böngésző párbeszédpaneljén.",
    },
    aed_detecting_hint: {
        sl: "Če se pogovorno okno ne prikaže ali si zavrnil, lahko vneseš tudi poštno številko.",
        es: "Si el diálogo no aparece o lo has rechazado, también puedes introducir un código postal.",
        cs: "Pokud se dialog neobjeví nebo jste odmítli, můžete zadat PSČ.",
        hu: "Ha a párbeszédpanel nem jelenik meg vagy elutasította, megadhat irányítószámot is.",
    },
    aed_enter_plz: {
        sl: "Vnesi poštno številko",
        es: "Introducir código postal",
        cs: "Zadat PSČ",
        hu: "Irányítószám megadása",
    },
    aed_manual_title: {
        sl: "Vnesi poštno številko",
        es: "Introducir código postal",
        cs: "Zadat PSČ",
        hu: "Irányítószám megadása",
    },
    aed_manual_sub: {
        sl: "Dostop do lokacije ni aktiven – vnesi poštno številko, da najdeš defibrilatorje v bližini.",
        es: "El acceso a la ubicación no está activo – introduce tu código postal para encontrar desfibriladores cercanos.",
        cs: "Přístup k poloze není aktivní – zadejte PSČ pro nalezení defibrilátorů v okolí.",
        hu: "A helyhozzáférés nem aktív – adja meg irányítószámát, hogy megtaláljuk a közeli defibrillátorokat.",
    },
    aed_manual_hint: {
        sl: "Namig: če brskalnik to podpira, lahko znova dovoliš dostop do lokacije.",
        es: "Consejo: también puedes volver a permitir el acceso a la ubicación si tu navegador lo soporta.",
        cs: "Tip: pokud to prohlížeč podporuje, můžete přístup k poloze znovu povolit.",
        hu: "Tipp: ha a böngésző támogatja, újra engedélyezheti a helyhozzáférést.",
    },
    aed_find_button: {
        sl: "Najdi defibrilatorje",
        es: "Encontrar desfibriladores",
        cs: "Najít defibrilátory",
        hu: "Defibrillátorok keresése",
    },
    aed_retry_gps: {
        sl: "Poskusi znova GPS",
        es: "Reintentar GPS",
        cs: "Zkusit GPS znovu",
        hu: "GPS újra",
    },
    aed_toast_invalid_plz: {
        sl: "Vnesite veljavno 5-mestno poštno številko.",
        es: "Introduce un código postal válido de 5 dígitos.",
        cs: "Zadejte platné 5místné PSČ.",
        hu: "Adjon meg érvényes 5 jegyű irányítószámot.",
    },
    aed_toast_plz_failed: {
        sl: "Poštne številke ni bilo mogoče prepoznati.",
        es: "No se pudo resolver el código postal.",
        cs: "PSČ se nepodařilo rozpoznat.",
        hu: "Az irányítószám nem azonosítható.",
    },
    aed_toast_no_geo: {
        sl: "Brskalnik ne podpira geolokacije.",
        es: "El navegador no admite geolocalización.",
        cs: "Prohlížeč nepodporuje geolokaci.",
        hu: "A böngésző nem támogatja a helymeghatározást.",
    },
    aed_toast_geo_denied: {
        sl: "Dostop do lokacije zavrnjen ali neuspešen.",
        es: "Permiso de ubicación denegado o fallido.",
        cs: "Povolení polohy zamítnuto nebo selhalo.",
        hu: "Helyengedély elutasítva vagy sikertelen.",
    },
    aed_placeholder_plz: {
        sl: "npr. 10115",
        es: "p. ej. 10115",
        cs: "např. 10115",
        hu: "pl. 10115",
    },

    // ---------------- DEFIBRILLATOR MAP ----------------
    map_section_label: {
        sl: "Defibrilatorji v bližini",
        es: "Desfibriladores cercanos",
        cs: "Defibrilátory v okolí",
        hu: "Defibrillátorok a közelben",
    },
    map_count: {
        sl: "{n} lokacij defibrilatorjev",
        es: "{n} ubicaciones de desfibriladores",
        cs: "{n} míst s defibrilátory",
        hu: "{n} defibrillátor-helyszín",
    },
    map_your_location: {
        sl: "Vaša lokacija",
        es: "Tu ubicación",
        cs: "Vaše poloha",
        hu: "Az Ön helye",
    },
    map_aed_label: {
        sl: "Defibrilator",
        es: "Desfibrilador",
        cs: "Defibrilátor",
        hu: "Defibrillátor",
    },
    map_you_are_here: {
        sl: "Tu si",
        es: "Estás aquí",
        cs: "Jste zde",
        hu: "Itt van",
    },
    map_operator: {
        sl: "Upravljavec",
        es: "Operador",
        cs: "Provozovatel",
        hu: "Üzemeltető",
    },
    map_indoor: {
        sl: "V zaprtih prostorih",
        es: "Interior",
        cs: "Uvnitř",
        hu: "Beltér",
    },
    map_outdoor: {
        sl: "Na prostem",
        es: "Exterior",
        cs: "Venku",
        hu: "Kültér",
    },
    map_opening_hours: {
        sl: "Odpiralni čas",
        es: "Horario",
        cs: "Otevírací doba",
        hu: "Nyitvatartás",
    },

    // ---------------- COMMON ----------------
    tts_activate: {
        sl: "Vklopi glas",
        es: "Activar voz",
        cs: "Zapnout hlas",
        hu: "Hang bekapcsolása",
    },
    tts_mute: {
        sl: "Izklopi glas",
        es: "Silenciar voz",
        cs: "Ztlumit hlas",
        hu: "Hang elnémítása",
    },
    reset_link: {
        sl: "Začni znova",
        es: "Empezar de nuevo",
        cs: "Začít znovu",
        hu: "Újrakezdés",
    },
    footer_powered_by: {
        sl: "Poganja SafetyAssist",
        es: "Desarrollado por SafetyAssist",
        cs: "Provozováno SafetyAssist",
        hu: "Üzemelteti: SafetyAssist",
    },
};
